export function usesHausInBrand() {
  return true;
}
